import React, { FC, useContext } from 'react';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';

import { Autorun } from './components';

export const AutorunBlock: FC = () => {
  const { t } = useContext(LocalizationContext);
  return (
    <>
      <SettingsBlock title={t('autorun')}>
        <SettingsFrame>
          <Autorun />
        </SettingsFrame>
      </SettingsBlock>
    </>
  );
};
